import { render, staticRenderFns } from "./DPlayerSettingSubtitles.vue?vue&type=template&id=6fdcd008&scoped=true&"
import script from "./DPlayerSettingSubtitles.vue?vue&type=script&lang=js&"
export * from "./DPlayerSettingSubtitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdcd008",
  null
  
)

export default component.exports